import styled from "styled-components";

export const Image = styled.img`
  width: 100%;
  margin-bottom: 1rem;
`;